"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
require("core-js/modules/es6.array.map.js");
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _omit = _interopRequireDefault(require("lodash/omit"));
var _classes = _interopRequireDefault(require("@nerdwallet/base-styles/classes"));
var _imageModule = _interopRequireDefault(require("./image.module.css"));
var _excluded = ["src", "srcSet", "sizes"];
/* eslint-disable react/no-array-index-key */
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
// eslint-disable-next-line import/no-unresolved -- directive added automatically by Shepherd migration
// Remove custom props that should not
// be applied to the DOM element
var omitExtraneous = function omitExtraneous(source) {
  return (0, _omit.default)(source, ['aspectRatio', 'backgroundColor', 'caption', 'children', 'className', 'expandToContent', 'imageClassName', 'lazy', 'naturalHeight', 'naturalWidth', 'objectFit', 'objectPosition', 'offset', 'overflow', 'placeholderImage', 'sources', 'fetchPriority']);
};
var Picture = function Picture(props) {
  var alt = props.alt,
    title = props.title,
    className = props.className,
    src = props.src,
    srcSet = props.srcSet,
    sizes = props.sizes,
    objectFit = props.objectFit,
    sources = props.sources,
    expandToContent = props.expandToContent,
    objectPosition = props.objectPosition,
    error = props.error,
    placeholderImage = props.placeholderImage,
    onLoad = props.onLoad,
    fetchPriority = props.fetchPriority;
  var imgProps = {
    alt: alt,
    title: title,
    className: (0, _classnames.default)(className, _imageModule.default.image, (0, _defineProperty2.default)({}, (0, _classes.default)('position-absolute'), expandToContent)),
    src: src,
    srcSet: srcSet,
    sizes: sizes,
    style: {
      objectPosition: objectPosition,
      objectFit: objectFit
    },
    onLoad: onLoad,
    fetchpriority: fetchPriority
  };
  if (error) {
    // Bail on sources, and render an img tag using placeholder image.
    delete imgProps.srcSet;
    imgProps.src = placeholderImage;

    /* `alt` is part of `imgProps` above. */
    /* eslint-disable-next-line jsx-a11y/alt-text */
    return /*#__PURE__*/_react.default.createElement("img", imgProps);
  }
  var fallbackSrc;

  // Multiple sources return a <picture> element
  var sourceTags = sources.map(function (source, index) {
    var _omitExtraneous = omitExtraneous(source),
      sourceSrc = _omitExtraneous.src,
      sourceSrcSet = _omitExtraneous.srcSet,
      sourceSizes = _omitExtraneous.sizes,
      sourceProps = (0, _objectWithoutProperties2.default)(_omitExtraneous, _excluded);
    if (sourceSrc && !fallbackSrc) {
      fallbackSrc = sourceSrc;
    }
    return /*#__PURE__*/_react.default.createElement("source", (0, _extends2.default)({}, sourceProps, {
      src: sourceSrc,
      srcSet: sourceSrcSet || sourceSrc,
      sizes: sourceSizes,
      key: index
    }));
  });
  return sources.length > 1 ? /*#__PURE__*/_react.default.createElement("picture", null, sourceTags, /*#__PURE__*/_react.default.createElement("img", (0, _extends2.default)({}, imgProps, {
    src: src || fallbackSrc
  }))) :
  /*#__PURE__*/
  // eslint-disable-next-line jsx-a11y/alt-text
  _react.default.createElement("img", (0, _extends2.default)({}, imgProps, omitExtraneous(sources[0])));
};
var _default = Picture;
exports.default = _default;